import __request__ from "routing/request";
export function listGrokPatterns(requestOptions) {
  return __request__("GET", "/system/grok", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createPattern(pattern, requestOptions) {
  return __request__("POST", "/system/grok", pattern, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkUpdatePatterns(patterns, importStrategy, requestOptions) {
  return __request__("PUT", "/system/grok", patterns, { "import-strategy": importStrategy }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkUpdatePatternsFromTextFile(patterns, importStrategy, requestOptions) {
  return __request__("POST", "/system/grok", patterns, { "import-strategy": importStrategy }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "name", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/grok/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testPattern(pattern, requestOptions) {
  return __request__("POST", "/system/grok/test", pattern, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listPattern(patternId, requestOptions) {
  return __request__("GET", `/system/grok/${patternId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updatePattern(patternId, pattern, requestOptions) {
  return __request__("PUT", `/system/grok/${patternId}`, pattern, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removePattern(patternId, requestOptions) {
  return __request__("DELETE", `/system/grok/${patternId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
